import DOMPurify from 'dompurify';
import { Trans, useTranslation } from 'react-i18next';

import { auth } from '../../../services/auth';
import { intercom } from '../../../services/intercom';
import { useStores } from '../../../stores/useStores';
import Button from '../../buttons/Button';
import { Dialog } from '../../Dialog/Dialog';
import { I18Text } from '../../i18Next/I18Text';

import styles from './AccountLockedDialog.module.scss';

const TEST_ID_PREFIX = 'account-locked-dialog';

const AccountLockedDialog = () => {
  const { authStore, portalStore } = useStores();
  const { t } = useTranslation();
  const isDirectLanding = authStore.isDirectLanding();

  const onClose = () => {
    portalStore.closePortal();
  };

  const handleOpenSupport = () => {
    if (!isDirectLanding) {
      portalStore.closePortal();
    }

    intercom.handleOpenSupport();
  };

  const renderMessage = () => {
    if (auth.selfExclusionCustomMsg) {
      if (auth.selfExclusionCustomMsg.isHtml) {
        const sanitizedText = DOMPurify.sanitize(auth.selfExclusionCustomMsg.playerNotificationText, {
          FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input'],
          FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur', 'onchange', 'onsubmit'],
          ALLOWED_URI_REGEXP: /^(?!javascript:).*/i, // block javascript: URLs
        });

        return <p dangerouslySetInnerHTML={{ __html: sanitizedText }} />;
      }

      return <p>{auth.selfExclusionCustomMsg.playerNotificationText}</p>;
    }

    return (
      <>
        <p data-testid="account-locked-text">
          <Trans components={{ bold: <b /> }} i18nKey="account.itSeemsAccountLocked" />
        </p>
        <b>
          <I18Text i18nKey="account.pleaseContactCustomerSupport" />
        </b>
      </>
    );
  };

  return (
    <Dialog
      forceNewDialogStyle
      isOpen
      classNameBackdrop={styles.backdrop}
      classNameParent={styles.dialog}
      closeBtnDataTestId={`${TEST_ID_PREFIX}-close-button`}
      dataTestId={TEST_ID_PREFIX}
      title={t('account.locked')}
      titleDataTestId={`${TEST_ID_PREFIX}-title`}
      onBackdropClick={onClose}
      onClose={onClose}
    >
      <div className={styles.content} data-testid={`${TEST_ID_PREFIX}-content`}>
        {renderMessage()}
      </div>

      <Button
        btnType="main"
        className={styles.okBtn}
        dataTestId={`${TEST_ID_PREFIX}-contact-support-button`}
        onClick={handleOpenSupport}
      >
        {t('common.contactSupportUpperCase')}
      </Button>
    </Dialog>
  );
};

export default AccountLockedDialog;
